import { ServiceIdentity, ServiceContainer } from '../service/RuntimeContext.js';

var LoggerLevel;
(function (LoggerLevel) {
    LoggerLevel[LoggerLevel["debug"] = 0] = "debug";
    LoggerLevel[LoggerLevel["info"] = 1] = "info";
    LoggerLevel[LoggerLevel["warn"] = 2] = "warn";
    LoggerLevel[LoggerLevel["error"] = 3] = "error";
    LoggerLevel[LoggerLevel["none"] = 4] = "none";
})(LoggerLevel || (LoggerLevel = {}));
const colorTable = {
    [LoggerLevel.info]: '#1890ff',
    [LoggerLevel.debug]: '#19be6b',
    [LoggerLevel.warn]: '#ff9900',
    [LoggerLevel.error]: '#ed4014'
};
const loggerLevelTable = {
    'debug': LoggerLevel.debug,
    'info': LoggerLevel.info,
    'warn': LoggerLevel.warn,
    'error': LoggerLevel.error,
    'none': LoggerLevel.none
};
class Logger {
    static get isBrowser() {
        return typeof navigator !== 'undefined';
    }
    static log(methodName, ctx, ...args) {
        if (ctx) {
            ctx.resolve(ServiceIdentity.Monitor).emitLog(loggerLevelTable[methodName], args);
        }
        if (!(ctx === null || ctx === void 0 ? void 0 : ctx.option.debug)) { // only check debug when use ctx mode
            return;
        }
        if (methodName === 'none') {
            return;
        }
        if (this.level <= LoggerLevel[methodName]) {
            if (ctx && ServiceContainer.Instance.instanceCount > 1) {
                if (Logger.isBrowser) {
                    console[methodName](`%c [Byted IM SDK][${ctx.id}] [${methodName}]:`, `color: ${colorTable[LoggerLevel[methodName]]}; font-weight: 700`, ...args);
                }
                else {
                    console[methodName](`[Byted IM SDK][${ctx.id}] [${methodName}]:`, ...args);
                }
            }
            else {
                if (Logger.isBrowser) {
                    console[methodName](`%c [Byted IM SDK] [${methodName}]:`, `color: ${colorTable[LoggerLevel[methodName]]}; font-weight: 700`, ...args);
                }
                else {
                    console[methodName](`[Byted IM SDK] [${methodName}]:`, ...args);
                }
            }
        }
    }
    static debug(...args) {
        this.log('debug', undefined, ...args);
    }
    static info(...args) {
        this.log('info', undefined, ...args);
    }
    static warn(...args) {
        this.log('warn', undefined, ...args);
    }
    static error(...args) {
        this.log('error', undefined, ...args);
    }
    // ctx version
    static ctxDebug(ctx, ...args) {
        this.log('debug', ctx, ...args);
    }
    static ctxInfo(ctx, ...args) {
        this.log('info', ctx, ...args);
    }
    static ctxWarn(ctx, ...args) {
        this.log('warn', ctx, ...args);
    }
    static ctxError(ctx, ...args) {
        this.log('error', ctx, ...args);
    }
}
Logger.level = LoggerLevel.debug;

export { Logger, LoggerLevel };
//# sourceMappingURL=logger.js.map
